import classNames from "classnames";

export const ErrorTips = ({ children, className = "", ...restProps }) => {
  return (
    <div
      className={classNames("text-[#FF2800] font-light", className)}
      {...restProps}
    >
      -- {children}
    </div>
  );
};
